import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleInfo,
  faTriangleExclamation,
  faLock,
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';

const VARIANTS = {
  information: { icon: faCircleInfo, color: 'var(--info)' },
  warning: { icon: faTriangleExclamation, color: 'var(--warning)' },
  security: { icon: faLock, color: 'var(--security)' },
  success: { icon: faCircleCheck, color: 'var(--success)' },
  critical: { icon: faCircleExclamation, color: 'var(--error)' },
};

// Compact, left-accent-bar inline notice — deliberately not a boxed card, so
// information/warning/security/success messages read as part of the
// conversation rather than as a dashboard alert.
export default function InlineNotice({ variant = 'information', text }) {
  if (!text) return null;
  const { icon, color } = VARIANTS[variant] || VARIANTS.information;

  return (
    <div style={{ ...s.wrap, borderLeftColor: color }}>
      <FontAwesomeIcon icon={icon} style={{ color }} aria-hidden="true" />
      <span style={s.text}>{text}</span>
    </div>
  );
}

const s = {
  wrap: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '6px 0 6px 10px',
    borderLeft: '2.5px solid',
    fontSize: 13,
    lineHeight: 1.6,
  },
  text: { color: 'var(--text-secondary)' },
};
